import { Button, TextField } from '@mui/material';
import { Form, Formik } from 'formik';
import { useDispatch } from 'react-redux';
import useHooks from 'src/hooks/useHooks';
import usePost from 'src/hooks/usePost';
import { logIn } from 'src/store/auth';
import { TUserData } from 'src/store/auth/Auth.types';
import { toast } from 'react-toastify';

const Login: React.FC = () => {
  const { navigate, get } = useHooks();
  const { mutate } = usePost();
  const dispatch = useDispatch();

  const handleSubmit = (values: { login: string; password: string }) => {
    const formData = new FormData();
    formData.append('username', values.login);
    formData.append('password', values.password);
    mutate({
      url: 'user/auth/',
      method: 'post',
      data: formData,
    }, {
      onSuccess: (data: any) => {
        const token = get(data, 'data.token');
        if (token) {
          const { token, ...restData } = data.data as TUserData;
          dispatch(
            logIn({
              isLoggedIn: true,
              token: token,
              data: { ...restData, token: token },
            })
          );
          navigate('/dashboards/podcast/list');
        }
      },
      onError: (error) => {
        toast.error('Login yoki parol xato!');
      }
    });
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        width: '50%',
        margin: '0 auto',
      }}
    >
      <h1>Login</h1>
      <Formik initialValues={{ login: "", password: "" }} onSubmit={handleSubmit}>
        {({ values, handleChange, handleSubmit }) => (
          <Form
            className="mr-5"
            style={{ display: 'flex', flexDirection: 'column', width: '40%' }}
            onSubmit={handleSubmit}
          >
            <TextField
              name="login"
              placeholder="Login"
              label="Login"
              type="text"
              value={values.login}
              onChange={handleChange}
              required
              sx={{ marginBottom: 2 }}
            />
            <TextField
              name="password"
              label="Password"
              type="password"
              autoComplete="current-password"
              value={values.password}
              onChange={handleChange}
              required
              sx={{ marginBottom: 2 }}
            />
            <Button
              sx={{ margin: 1 }}
              color="secondary"
              variant="outlined"
              type="submit"
              size="large"
              style={{ textAlign: "center" }}
            >
              Login
            </Button>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default Login;
